export const createDropdownVisibleChangeHandler = (
  fetchFunction: () => void
) => {
  return (isOpen: boolean) => {
    if (isOpen) {
      fetchFunction();
    }
  };
};
